import { HttpParams } from '@angular/common/http';
import { toHTTPParam } from '../../../../core';
import { Periodicidade, periodicidadeMensal, isPeriodicidadePeriodo } from '../../../../shared';
import { Filter } from '../../../../models';
import { AreaSearch } from '../../../areas';
import { Cliente } from '../../../pessoa/cliente/cliente';
import { Pessoa } from '../../../pessoa/pessoa';

/** Representa o Filter da pesquisa das campanhas */
export class CampanhaFilter implements Filter {
    isFilterDirty = false;


    // Periodicidade Vigência
    periodicidadeVigencia: number;
    dataInicioVigencia: Date;
    dataTerminoVigencia: Date;
    dataInicioVigenciaPeriodo: Date;
    dataTerminoVigenciaPeriodo: Date;
    mesVigencia: number;
    trimestreVigencia: number;
    semestreVigencia: number;
    anoVigencia: number;

    somenteEmUso = true;
    filterPsq: string;
    idArea: number;
    area: AreaSearch;
    statuses: number[] = [];
    idsPacotes: number[] = [];
    somentePacotesAtivos = true;
    sobDemanda: boolean;
    objetivoVenda: boolean;
    objetivoVendaIn: boolean;
    objetivoBonificacao: boolean;
    objetivoBonificacaoIn: boolean;
    objetivoAquisicao: boolean;
    objetivoAquisicaoIn: boolean;

    idsRepresentantes: number[] = [];
    somenteRepresentantesAtivos = true;
    idClienteVinculado: number;
    clienteVinculado: Cliente;
    somenteClientesVinculados: boolean;
    idPessoa: number;
    pessoa: Pessoa;
    tiposPromocoes: number[] = [];
    tipoPromocaoNull = false;
    idsGerentes: number[] = [];
    idsAtendentes: number[] = [];

    constructor(periodicidadeVigencia: Periodicidade = periodicidadeMensal) {
        this.periodicidadeVigencia = periodicidadeVigencia ? periodicidadeVigencia.id : null;
    }

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Periodicidade Vigência
        if (this.periodicidadeVigencia) {
            params = params.append('periodicidadeVigencia', this.periodicidadeVigencia.toString());
        }

        if (isPeriodicidadePeriodo(this.periodicidadeVigencia)) {
            // Data Início Vigência
            if (this.dataInicioVigenciaPeriodo) {
                params = params.append('dataInicioVigencia', toHTTPParam(this.dataInicioVigenciaPeriodo));
            }
            // Data Término Vigência
            if (this.dataTerminoVigenciaPeriodo) {
                params = params.append('dataTerminoVigencia', toHTTPParam(this.dataTerminoVigenciaPeriodo));
            }
        } else {
            // Data Início Vigência
            if (this.dataInicioVigencia) {
                params = params.append('dataInicioVigencia', toHTTPParam(this.dataInicioVigencia));
            }
            // Data Término Vigência
            if (this.dataTerminoVigencia) {
                params = params.append('dataTerminoVigencia', toHTTPParam(this.dataTerminoVigencia));
            }
        }

        // Somente vigente
        if (this.somenteEmUso) {
            params = params.append('somenteEmUso', this.somenteEmUso.toString());
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Área
        if (this.idArea) {
            params = params.append('idArea', this.idArea.toString());
        }

        // Statuses
        this.statuses?.forEach(status => {
            params = params.append('status', status.toString());
        });

        // Pacotes
        this.idsPacotes?.forEach(idPacote => {
            params = params.append('idPacote', idPacote.toString());
        });

        // Sob demanda
        if (this.sobDemanda != null && this.sobDemanda !== undefined) {
            params = params.append('sobDemanda', this.sobDemanda.toString());
        }

        // Objetivo de venda
        if (this.objetivoVenda != null && this.objetivoVenda !== undefined) {
            params = params.append('objetivoVenda', this.objetivoVenda.toString());
        }
        if (this.objetivoVendaIn != null && this.objetivoVendaIn !== undefined) {
            params = params.append('objetivoVendaIn', this.objetivoVendaIn.toString());
        }
        // Objetivo de bonificação
        if (this.objetivoBonificacao != null && this.objetivoBonificacao !== undefined) {
            params = params.append('objetivoBonificacao', this.objetivoBonificacao.toString());
        }
        if (this.objetivoBonificacaoIn != null && this.objetivoBonificacaoIn !== undefined) {
            params = params.append('objetivoBonificacaoIn', this.objetivoBonificacaoIn.toString());
        }
        // Objetivo de aquisição
        if (this.objetivoAquisicao != null && this.objetivoAquisicao !== undefined) {
            params = params.append('objetivoAquisicao', this.objetivoAquisicao.toString());
        }
        if (this.objetivoAquisicaoIn != null && this.objetivoAquisicaoIn !== undefined) {
            params = params.append('objetivoAquisicaoIn', this.objetivoAquisicaoIn.toString());
        }

        // Representantes
        this.idsRepresentantes?.forEach(idRepresentante => {
            params = params.append('idRepresentante', idRepresentante.toString());
        });

        // Cliente vinculado diretamente à campanha
        if (this.idClienteVinculado) {
            params = params.append('idClienteVinculado', this.idClienteVinculado.toString());

            // Somente filtrar clientes diretamente vinculados à campanha
            if (this.somenteClientesVinculados != null && this.somenteClientesVinculados !== undefined) {
                params = params.append('somenteClientesVinculados', this.somenteClientesVinculados.toString());
            }
        }

        // Pessoa
        if (this.idPessoa) {
            params = params.append('idPessoa', this.idPessoa.toString());
        }

        // Tipos de Promoções
        this.tiposPromocoes?.forEach(tipoPromocao => {
            if (tipoPromocao > 0) {
                params = params.append('tipoPromocao', tipoPromocao.toString());
            }
        });
        // Sem tipo de promoção
        if (this.tipoPromocaoNull) {
            params = params.append('tipoPromocaoNull', 'true');
        }

        // Gerentes
        this.idsGerentes?.forEach(idGerente => {
            params = params.append('idsGerentes', idGerente.toString());
        });

        // Atendentes
        this.idsAtendentes?.forEach(idAtendente => {
            params = params.append('idsAtendentes', idAtendente.toString());
        });

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.somenteEmUso = true;
        this.filterPsq = null;
        this.statuses = [];
        this.idsPacotes = [];
        this.somentePacotesAtivos = true;
        this.sobDemanda = null;
        this.objetivoVenda = null;
        this.objetivoVendaIn = null;
        this.objetivoBonificacao = null;
        this.objetivoBonificacaoIn = null;
        this.objetivoAquisicao = null;
        this.objetivoAquisicaoIn = null;

        this.idsRepresentantes = [];
        this.somenteRepresentantesAtivos = true;
        this.idClienteVinculado = null;
        this.clienteVinculado = null;
        this.somenteClientesVinculados = null;
        this.idPessoa = null;
        this.pessoa = null;
        this.tiposPromocoes = [];
        this.tipoPromocaoNull = false;
        this.idsGerentes = [];
        this.idsAtendentes = [];
    }


    /** Verificar se o filtro possui a periodicidade da vigência considerando a periodicidade e data de início da vigência */
    possuiPeriodicidadeVigencia(): boolean {
        // Periodicidade Vigência
        if (!this.periodicidadeVigencia) {
            return false;
        }
        // Data Início Vigência
        if (!this.dataInicioVigencia) {
            return false;
        }

        return true;
    }
}

